import React, {Component} from 'react'

export default ()=>{
    return(
        <div className="game-over-container">
            <p>Game Over</p>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/GameOver.js